const _ = require('lodash');
const languageTemplate1 = require('./templates/language-control-template-1.hbs');

const controlElementId = 'uc-btn-open-language-selector-flags';
const languageElementClassName = 'language-item';
const languageListToggleId = 'uc-lang-dropdown-toggle';

//const _defaultLanguage = "en";

const languagesMapper = [
	{
		label: 'English',
		isoCode: 'EN',
		image: require('../../../../img/flags/en.hbs')(),
	},
	{
		label: 'German',
		isoCode: 'DE',
		image: require('../../../../img/flags/de.hbs')(),
	},
	{
		label: 'French',
		isoCode: 'FR',
		image: require('../../../../img/flags/fr.hbs')(),
	},
	{
		label: 'Spanish',
		isoCode: 'ES',
		image: require('../../../../img/flags/es.hbs')(),
	},
	{
		label: 'Italian',
		isoCode: 'IT',
		image: require('../../../../img/flags/it.hbs')(),
	},
	{
		label: 'Dutch',
		isoCode: 'NL',
		image: require('../../../../img/flags/nl.hbs')(),
	},
	{
		label: 'Polish',
		isoCode: 'PL',
		image: require('../../../../img/flags/pl.hbs')(),
	},
	{
		label: 'Danish',
		isoCode: 'DA',
		image: require('../../../../img/flags/dk.hbs')(),
	},
	{
		label: 'Hungarian',
		isoCode: 'HU',
		image: require('../../../../img/flags/hu.hbs')(),
	},
	{
		label: 'Finnish',
		isoCode: 'FI',
		image: require('../../../../img/flags/fi.hbs')(),
	},
	{
		label: 'Norwegian',
		isoCode: 'NO',
		image: require('../../../../img/flags/no.hbs')(),
	},
	{
		label: 'Slovenian',
		isoCode: 'SL',
		image: require('../../../../img/flags/sl.hbs')(),
	},
	{
		label: 'Czech',
		isoCode: 'CS',
		image: require('../../../../img/flags/cs.hbs')(),
	},
	{
		label: 'Swedish',
		isoCode: 'SV',
		image: require('../../../../img/flags/sv.hbs')(),
	},
	{
		label: 'Romanian',
		isoCode: 'RO',
		image: require('../../../../img/flags/ro.hbs')(),
	},
	{
		label: 'Slovak',
		isoCode: 'SK',
		image: require('../../../../img/flags/sk.hbs')(),
	},
	{
		label: 'Croatia',
		isoCode: 'HR',
		image: require('../../../../img/flags/hr.hbs')(),
	},
	{
		label: 'Portuguese',
		isoCode: 'PT',
		image: require('../../../../img/flags/pt.hbs')(),
    },
    {
		label: 'Chinese',
		isoCode: 'ZH',
		image: require('../../../../img/flags/cn.hbs')(),
	},
    {
		label: 'russian',
		isoCode: 'RU',
		image: require('../../../../img/flags/ru.hbs')(),
	}
];

export default class LanguageDirective {
	private utilityService: any;
	private settingsService: any;
	private langListOpened: boolean = false;

	private selectedLanguage: any;

	constructor(utilityService) {
		this.utilityService = utilityService;
		this.settingsService = utilityService.settingsService;
		this.selectedLanguage = this.settingsService.language;
	}

	public get fullLanguagesList() {
		return _.filter(languagesMapper, lan => {
			return ~(
				_.map(this.settingsService.settings.languagesAvailable, language => {
					return language.toUpperCase();
				}) || []
			).indexOf(lan.isoCode);
		});
	}

	private toggleList() {
		this.langListOpened = !this.langListOpened;
		this.utilityService.UserCentricViewController.updateView();
	}

	public setLanguage = (langCode: any) => {
		this.selectedLanguage = langCode.toLowerCase();
		this.langListOpened = false;
		this.settingsService.changeInterfaceLanguage(this.selectedLanguage);
	};

	public getLanguage = () => {
		return this.selectedLanguage;
	};

	private getHtml(parent?) {
		const viewHTML: any = languageTemplate1;
		const isFlag = this.settingsService.settings.languageSelectorType == 2 ? true : false;
		const languages = _.map(this.fullLanguagesList, lang => {
			return _.assign({}, lang, {
				active: lang.isoCode.toLowerCase() === this.selectedLanguage,
			});
		});
		const selectedLanguage = _.filter(this.fullLanguagesList, lang => {
			return lang.isoCode.toLowerCase() === this.selectedLanguage;
		})[0];
		const viewData = {
			languages: languages,
			selectedLanguage: selectedLanguage,
			langListOpened: this.langListOpened,
			settings: this.settingsService.settings,
			isFlag: isFlag,
			bgColor:
				parent && parent === 'uc-corner-modal'
					? this.settingsService.settings.styles.cornerModalHeaderBgColor
					: this.settingsService.settings.styles.btnPrivacyButtonBgColor,

			//visible: !this.settingsService._settings.showLanguageDropdown
		};
		return viewHTML(viewData);
	}

	public initHandling() {
		if (this.visible) {
			const controlWrapperElement = document.getElementById(controlElementId);
			if (controlWrapperElement) {
				const langListToggleElement: any = controlWrapperElement.querySelector(
					'#' + languageListToggleId
				);
				if (langListToggleElement) {
					langListToggleElement.onclick = () => {
						this.toggleList();
					};
				}

				const langElements = controlWrapperElement.getElementsByClassName(
					languageElementClassName
				);

				_.forEach(langElements, lan => {
					lan.onclick = () => {
						this.setLanguage(lan.id.slice(-2));
					};
				});
			}
		}
	}

	public get visible() {
		return (
			this.settingsService.elementsVisibility.languageService === 2 ||
			this.settingsService.elementsVisibility.languageService === 3
		);
	}

	public htmlString(parent?): string {
		if (this.visible) {
			return this.getHtml(parent);
		}
		return '';
	}
}
